export default "__VITE_ASSET__Csf3TB3j__"